import React, { useState } from 'react';
import CholaKaartLosJourneyFAQs from './CholaKaartLosJourneyFAQs';

function Faq() {
  const [searchTerm, setSearchTerm] = useState('');
  const [showSearchModal, setShowSearchModal] = useState(false);

  return (
    <CholaKaartLosJourneyFAQs
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      showSearchModal={showSearchModal}
      setShowSearchModal={setShowSearchModal}
    />
  );
}

export default Faq;
